/**
 * Reemplaza las citaciones del mensaje
 * @param {string} message Indica el mensaje para reemplazar las citaciones
 * @returns {string} Devuelve mensaje con las citaciones
 */
export function replaceCitations(message: string): {message: string, citations: string[]} {
    // Crea un regex para buscar las referencias dentro de la respuesta del asistente que se componen por [doc#]
    const regex = /\[doc\d+\]|\(doc\d+\)|\[^doc\d+\^]|\[doc_\d+\]|\(doc_\d+\)|\[^doc_\d+\^]/g;
    // Obtiene las referencias donde encuentre [doc#] donde # es el núnmero de referencia
    const found = message.match(regex);
    // Crea un array de las referencias encontradas con el patrón
    const newfound =  [...new Set(found)];

    // Se reemplaza los valores de los documentos
    newfound.forEach((value, i) => {
      // Crea un patron de expresiones regulares
      var pattern = new RegExp(`(\\${value})`);
      do {
        // Reempleaza el patrón de la referencia por el número que corresponde
        message = message.replace(pattern,`<b><sup class='quote' style='font-weight: 600;font-size: 12px;color: black;'>${i + 1}</sup></b>`);
      } while(pattern.test(message)); // Ejecuta lo de reemplazo de citaciones hasta que ya no encuentre una citación dentro del mensaje
    });

    return {
      message: message,
      citations: newfound.map(v => `doc_${(v.match(/\d+/)[0])}`) // Obtiene el número de referencia
    }
}

/**
 * Reemplaza las los documentos que contengan corchetes y guiones bajos
 * @param {string} message Indica el mensaje para reemplazar los corchetes y guiones bajos
 * @returns {string} Devuelve mensaje con los corchetes y guiones bajos
 */
export function replaceDocuments(message: string): string {
    // Reemplaza el resto de referencias con vacío
    return message.replace(/[(\[_\])]/g," ");
}
